<div class="popup" *ngIf="isOpen" (click)="closePopup()">
  <div class="popup-content">
    <span class="close-btn" (click)="closePopup()">×</span>
    <div id="main" (click)="$event.stopPropagation()">
      <mat-dialog-content>
        <div class="top-row">
          <img
            *ngIf="selectedAsset.assetTypeClassification === 0"
            src="/img/RoRo.png"
            class="asset-icon"
          />
          <img
            *ngIf="selectedAsset.assetTypeClassification === 1"
            src="/img/Skip.png"
            class="asset-icon"
          />
          <mat-form-field id="selectList" appearance="fill" class="dropdown" *ngIf="containers?.length && containers?.length > 1">
            <mat-label>Select</mat-label>
            <mat-select [(value)]="selectedId" (selectionChange)="onAssetChange($event)">
              <mat-option *ngFor="let container of containers" [value]="container.containerName">
                {{ (container.containerName + " (" + container.containerType) + ")" }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="info-grid">
          <div class="info-cell">
            <span class="label">ID</span>
            <span>{{ selectedAsset.containerName }}</span>
          </div>
          <div class="info-cell">
            <span class="label">Type</span>
            <span>{{ selectedAsset.containerType }}</span>
          </div>
          <div class="info-cell">
            <span class="label">On Site</span>
            <span>{{ selectedAsset.daysOnSiteDisplay }}</span>
          </div>
          <div class="info-cell">
            <span class="label">Status</span>
            <span>{{ selectedAsset.statusDisplay }}</span>
          </div>
          <div class="info-cell" *ngIf="selectedAsset.externalReference || selectedAsset.wasteTypeName">
            <span class="label">Contract</span>
            <span>{{ selectedAsset.externalReference }}</span>
          </div>
          <div class="info-cell" *ngIf="selectedAsset.externalReference || selectedAsset.wasteTypeName">
            <span class="label">Waste</span>
            <span>{{ selectedAsset.wasteTypeName }}</span>
          </div>
        </div>
      </mat-dialog-content>
    </div>
    <br>
    <div id="image">
      <img [src]="selectedAsset.assetURL ?? imageSrc" alt="Popup Image" />
    </div>
  </div>
</div>
  